<form nz-form *ngIf="mainformGroup" [formGroup]="mainformGroup">
    <nz-table  *ngIf="!field.hidden"
            [nzPaginationType]="'small'"
            [nzShowPagination]="true"
            [nzSize]="'small'"
            [nzPageSize]="pageSize"
            [nzPageIndex]="pageIndex"
            [nzFrontPagination]="false" 
            [nzData]="pagedRows" 
            [nzBordered]="true" 
            [nzTotal]="rows.length"
            (nzPageIndexChange)="pageIndex = $event"
            >
        <thead>
        <tr>
            <th colspan="4">{{'key'|translateTA}}</th>
            <th colspan="4">{{'value'|translateTA}}</th>
            <th colspan="1">{{'action'|translateTA}}</th>
        </tr>
        </thead>
        <tbody >
            <tr [formGroup]="newRow" *ngIf="!field.isDisabled">
                <td colspan="4"><input nz-input formControlName="key" [nzAutocomplete]="autoKey" [placeholder]="'key'|translateTA" /></td>
                   
                <td colspan="4">
                    <nz-input-group [nzPrefix]="formulaTplNewRow" >
                        <input nz-input formControlName="value" [nzAutocomplete]="autoValue" [placeholder]="'value'|translateTA" />
                    </nz-input-group>
                </td>
                 
                <td colspan="1">
                    <button nz-button  nzType="primary" style="color: #ccecb8;" nzShape="circle" (click)="addRow()">
                        <nz-icon nzType="check" />
                    </button>
                </td>
            </tr>
            <tr *ngFor="let row of pagedRows; let i = index"  >
                <td colspan="4"><input nz-input [(ngModel)]="row.key" [ngModelOptions]=" {standalone: true}" disabled/></td>
                <td colspan="4">
                    <nz-input-group [nzPrefix]="formulaTpl" >
                        <input nz-input [formControl]="row.control" [disabled]="field.isDisabled" />
                    </nz-input-group>
                </td>
                <td colspan="1" *ngIf="!field.isDisabled">
                        <button nz-button  nzType="primary" style="color: #ccecb8;" nzShape="circle" (click)="removeRow(i)">
                            <nz-icon nzType="delete" style="color: #ccecb8;" />
                        </button>
                </td>
                <ng-template #formulaTpl>
                    <nz-icon nzType="thunderbolt" (click)="openFormula(row.control.value,row.control)"/>    
                </ng-template>
            </tr>
        </tbody>
    </nz-table>
</form>

 <nz-autocomplete #autoKey>
    <nz-auto-option *ngFor="let option of filteredAutoCompleteKey"  [nzValue]="option">
        {{ option }}
    </nz-auto-option>
</nz-autocomplete>
    <nz-autocomplete #autoValue>
    <nz-auto-option *ngFor="let option of filteredAutoCompleteValue" [nzValue]="option">
        {{ option }}
    </nz-auto-option>
</nz-autocomplete>

<ng-template #formulaTplNewRow>
    <nz-icon nzType="thunderbolt" (click)="openFormula(newRow.get('value').value,newRow.get('value'))"/>    
</ng-template>

